<section class="accordion-item" *ngIf="profile && settings">
  <div *ngIf="profile.isBusiness" class="row align-items-center">
    <div
      class="accordion-item__title"
      [translate]="'settings.notifications.refund-request-notification'"
    ></div>

    <div
      class="form-check custom-control custom-switch accordion-item__check-container"
    >
      <input
        type="checkbox"
        class="form-check-input custom-control-input"
        id="{{ 'input-refund-' + index }}"
        [(ngModel)]="settings.eCreditsNotifyRefundRequest"
        (ngModelChange)="onTypeChange($event)"
      />
      <label
        id="{{ 'label-refund-' + index }}"
        class="form-check-label custom-control-label"
        for="{{ 'input-refund-' + index }}"
      ></label>
    </div>
  </div>

  <div class="row accordion-item__transfer-row transfer-row">
    <div
      class="transfer-row__title"
      [translate]="'settings.notifications.ecredits-incoming-transfer'"
    ></div>
    <div
      class="form-check custom-control custom-switch accordion-item__check-container"
    >
      <input
        type="checkbox"
        class="form-check-input custom-control-input"
        id="{{ 'input-incoming-' + index }}"
        [(ngModel)]="settings.eCreditsNotifyIncomingTransfer"
        (ngModelChange)="onTypeChange($event)"
      />
      <label
        id="{{ 'label-incoming-' + index }}"
        class="form-check-label custom-control-label"
        for="{{ 'input-incoming-' + index }}"
      ></label>
    </div>
  </div>

  <div class="row accordion-item__threshold-row threshold-row">
    <div
      class="threshold-row__title"
      [translate]="'settings.notifications.ecredits-threshold'"
    ></div>

    <div class="group google-input threshold-row__input-container">
      <input
        type="number"
        min="0"
        id="{{ 'incoming-amount-input-' + index }}"
        class="threshold-row__input"
        [(ngModel)]="settings.eCreditsIncomingTransferAmountMinimum"
        (ngModelChange)="onTypeChange($event)"
        [disabled]="!settings.eCreditsNotifyIncomingTransfer"
      />
      <span class="highlight"></span>
      <span class="bar"></span>
    </div>
    <span class="threshold-row__input-postfix">{{
      currencyCodePrefix + balanceTypes.eCredits | translate
    }}</span>
  </div>

  <section class="accordion-item__buttons-container">
    <ng-container *ngIf="edited">
      <button
        class="btn btn-primary accordion-item__button-cancel"
        type="button"
        (click)="cancel($event)"
      >
        {{ "shared.buttons.cancel" | translate }}
      </button>
      <button
        class="btn btn-primary accordion-item__button-save"
        type="button"
        (click)="onSave()"
      >
        {{ "shared.buttons.save" | translate }}
      </button>
    </ng-container>
  </section>
</section>
